module.exports = __webpack_public_path__ + "img/vietnam.98e8fea6.svg";